import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { ReactComponent as LogoIcon } from '../../assets/images/logo_light.svg'
import { ReactComponent as SuccessCardIcon } from '../../assets/images/card/success_card.svg'
import { ReactComponent as BannerImage } from '../../assets/images/banner/banner-1.svg'
import './homepage.scss'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import CompleteProfile from '../../Components/Common/CompleteProfile'
import { gethomeDashboardInfo, getProfileStatus, getUserDetails, getWithdrawRecent, cancelRequestService } from '../../API/Services/authService'
import ProfileStatus from '../../Components/ProfileStatusModal/ProfileStatus'
import { RouterConstant } from '../../constants/RouteConstant'
import LoaderWrapper from '../../Components/LoaderWrapper/LoaderWrapper'
import { getDateFromNo } from '../../helper/dateData'
import ErrorModal from '../../Components/ErrorModal/ErrorModal'
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from 'moment/moment'


const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};

const HomePage = () => {
    let navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false)
    const [errorPopup, setErrorPopup] = useState(false)
    const [loader, setLoader] = useState(false);
    const [checkProfileStatus, setCheckProfileStatus] = useState(false);
    const [notUpdate, setNotUpdate] = useState('hide');
    const [customMessage, setCustomMessage] = useState('hide');
    const [user, setUser] = useState({})
    const [homeData, setHomeData] = useState({})
    const [withdrawalData, setWithdrawalData] = useState([])
    const [date, setDate] = useState('')
    const [requestId, setRequestId] = useState('')
    const [confirmModal, setConfirmModal] = useState(false)
    const handleToggleProfileStatus = () => {
        setIsOpen(!isOpen)
    }

    const handleErrorPopup = () => {
        setErrorPopup(!errorPopup)
    }

    useEffect(() => {
        let date = new Date();
        setDate(date)
    }, [])

    useEffect(() => {
        getProfileStatus()
            .then(response => {
                setLoader(false)
                if (response?.data?.status === 'OK') {
                    setCheckProfileStatus(response?.data?.data?.isAllDetailsVerified)
                }
                else {
                    console.log('Error response-->', response)
                }
            })
            .catch(error => {
                console.log(error)
                setLoader(false)
            })
    }, [])

    // check verification

    useEffect(() => {
        setLoader(true)
        getUserDetails()
            .then((response) => {
                setLoader(false)
                if (response?.data?.status === 'OK') {
                    setUser(response?.data?.data?.user)
                    if (
                        response?.data?.data?.user?.kycDetails?.status === 0 ||
                        response?.data?.data?.user?.bankDetails?.status === 0 ||
                        response?.data?.data?.user?.workDetails?.status === 0
                    ) {
                        setNotUpdate('show')
                        setCustomMessage('Your profile is not complete, Kindly complete the signup process')
                    } else {
                        setNotUpdate('hide')
                        setCustomMessage(response?.data?.message)
                    }
                }
                else {
                    console.log('Error response-->', response)
                }
            })
            .catch((error) => {
                setLoader(false)
                console.log('Error response-->', error)
            })
    }, [])

    // home dashboard info
    useEffect(() => {
        setLoader(true)
        gethomeDashboardInfo()
            .then((response) => {
                setLoader(false)
                if (response?.data?.status === 'OK') {
                    setHomeData(response?.data?.data?.homedata)
                }
                else {
                    console.log('Error response-->', response)
                }
            })
            .catch((error) => {
                setLoader(false)
                console.log('Error response-->', error)
            })
    }, [])

    const money = (v) => `N ${Number(v || 0).toLocaleString()}`;
const getAmount = (r) => r?.amount ?? r?.requestedAmount ?? 0;

const getStatusView = (s) => {
  if (!s) return { text: '-', cls: '' };
  const key = String(s).toLowerCase();
  if (key === 'advancestatuslive' || key === 'paid' || key === 'success') {
    return { text: 'Paid', cls: 'approved' };
  }
  if (key === 'approved') return { text: 'Approved', cls: 'approved' };
  if (key === 'pending') return { text: 'Pending', cls: 'pending' };
  if (key === 'rejected' || key === 'declined') return { text: 'Rejected', cls: 'rejected' };
  return { text: s, cls: '' };
};

const getTypeTitle = (t) => {
  if (!t) return 'Request';
  if (t === 'salaryAdvance') return 'Salary Advance';
  if (t === 'salaryTopUp') return 'Salary Top-Up';
  return t.replace(/([a-z])([A-Z])/g, '$1 $2'); // pretty-print camelCase
};

const nextDueOf = (r) => {
  // salaryAdvance: prefer dueDate / salaryDueDate
  if (r?.type === 'salaryAdvance') {
    if (r?.dueDate) return moment(r.dueDate).format('DD MMM, YYYY');
    if (r?.salaryDueDate) {
      // accept both "DD-MM-YYYY" and "14" forms
      const sd = r.salaryDueDate;
      if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(sd)) {
        const [d,m,y] = sd.split('-').map(Number);
        const iso = new Date(y, m - 1, d);
        return moment(iso).format('DD MMM, YYYY');
      }
      if (/^\d{1,2}$/.test(String(sd))) {
        // show as "Due on 14"
        return `Due on ${sd}`;
      }
      return sd;
    }
    return '-';
  }

  // salaryTopUp: compute next future installment; if none, show last
  const bd = Array.isArray(r?.paymentBreakdown) ? r.paymentBreakdown : [];
  if (!bd.length) return '-';
  const now = Date.now();
  const future = bd
    .map(b => new Date(b.dueDate))
    .filter(d => !isNaN(d.getTime()) && d.getTime() >= now)
    .sort((a,b) => a.getTime() - b.getTime());
  const pick = future[0] || new Date(bd[bd.length - 1].dueDate);
  return moment(pick).format('DD MMM, YYYY');
};

const installmentsSummary = (r) => {
  if (r?.type !== 'salaryTopUp') return null;
  const bd = Array.isArray(r?.paymentBreakdown) ? r.paymentBreakdown : [];
  if (!bd.length) return null;
  const per = bd[0]?.amount;
  const perNum = per != null ? (typeof per === 'string' ? parseFloat(per) : Number(per)) : 0;
  return `${bd.length} × ${money(perNum)}`;
};


    const getWithdrawRecentList = () => {
        setLoader(true)
        getWithdrawRecent()
            .then(response => {
                setLoader(false)
                if (response?.data?.status === 'OK') {
                    setWithdrawalData(response?.data?.data?.withdrawalData)
                }
            })
            .catch(error => {
                setLoader(false)
                console.log("Error Withdraw=>", error)
            })
    }

    // winthdrawal recent
    useEffect(() => {
        getWithdrawRecentList();
    }, [])

    const redirectToRequest = () => {
        // if (notUpdate === "show") {
        navigate(RouterConstant.Request);
        // } else {
        //     handleErrorPopup()
        // }
    }


    const cancelRequest = () => {
        let params = {requestId}
        setConfirmModal(false);
        cancelRequestService(params)
            .then(response => {
                setRequestId('');
                if (response?.data?.status === 'OK') {
                    getWithdrawRecentList();
                }
            })
            .catch(error => {
                console.log("Error Withdraw=>", error)
            })

    }


    const handleCancelModal = (id) => {
        setRequestId(id);
        setConfirmModal(true)
    }


    return (
        <>

        <Modal
            isOpen={confirmModal}
            toggle={() => setConfirmModal(false)}
        >
            <ModalHeader toggle={() => setConfirmModal(false)} className='error-header'>
                Confirm
            </ModalHeader>
            <ModalBody className="error-body ">
                <p>Are you sure you want to cancel Request ?</p>
                <div className='btn_groups'>
                    <span onClick={() => setConfirmModal(false)} className='btn btn-dark d-inline'>No</span>
                    <span onClick={cancelRequest} className='btn btn-primary d-inline'>Yes</span>
                </div>
            </ModalBody>
        </Modal>


            {loader ? <LoaderWrapper /> :
                <div className="homepage-wrapper">
                    {/* banner section */}
                    <div className="home-inner-wrapper">
                        {/* <div className="banner-wrapper">

                            <Slider {...settings}>
                                <div className="carousel-custom-slide">
                                    <h3 className="heading">You deserve to be paid 1</h3>
                                    <p className="text">Incash helps you to get paid <br />for your work when you really need it</p>
                                </div>
                                <div className="carousel-custom-slide">
                                    <h3 className="heading">You deserve to be paid 2</h3>
                                    <p className="text">Incash helps you to get paid <br />for your work when you really need it</p>
                                </div>
                                <div className="carousel-custom-slide">
                                    <h3 className="heading">You deserve to be paid 3</h3>
                                    <p className="text">Incash helps you to get paid <br />for your work when you really need it</p>
                                </div>
                            </Slider>
                        </div> */}
                        {/* banner section end*/}
                        <div className="home-card-wrapper-one">
                            <div className="card-one">
                                <div className="content">
                                    <p className="card-heading">Approved Limit</p>
                                    <p className="card-text">{`N ${homeData?.accountLimit?homeData?.accountLimit:'-'}`}</p>
                                </div>
                                <div className="content line-wrapper mb-0">
                                    <p className="card-heading">Monthly Salary</p>
                                    <p className="card-text">{`N ${homeData?.monthlySalary?homeData?.monthlySalary:'-'}`}</p>
                                </div>
                            </div>

                            <div className="home-card-wrapper-two cursor-pointer">
                                <div onClick={redirectToRequest} className="card-two">
                                    <div className="logo-icon-wrapper">
                                        <LogoIcon className="logo-light" />
                                    </div>
                                    <div className="card-background">
                                    </div>
                                    <div className="card-heading">
                                        Get Money Now
                                    </div>
                                    <div className="card-text">
                                        Pay a minimal interest on cash loan as low as N40/day
                                    </div>
                                </div>
                            </div>

                            <div className="card-one pd-3">
                                <div className="content line-wrapper">
                                    <p className="card-heading">Withdrawal Funds</p>
                                    <p className="card-text">{`N ${homeData?.withdrawnAmount==0||homeData?.withdrawnAmount?homeData?.withdrawnAmount:'-'}`}</p>
                                </div>
                                <div className="content mb-0">
                                    <p className="card-heading">Available Balance</p>
                                    <p className="card-text">{`N ${(homeData?.accountLimit - homeData?.withdrawnAmount)?(homeData?.accountLimit - homeData?.withdrawnAmount):'-'}`}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <aside className="recent-request">
                        <div className="request-header">
                            <h2 className="request-heading">Recent Requests</h2>
                            <Link to={RouterConstant.transaction} className="view-all">View All</Link>
                        </div>
                       <div className="recent-list-wrapper">
  {
  withdrawalData?.map((recent, index) => {
    const id = recent?.id || recent?._id || index;
    const createdISO =
      recent?.createdAt ||
      (recent?.createdDate ? new Date(recent.createdDate).toISOString() : null);

    // amount (prefer amount, fallback requestedAmount)
    const amountNum = Number(recent?.amount ?? recent?.requestedAmount ?? 0);

    // status mapping → text + class
    const statusKey = String(recent?.status || '').toLowerCase();
    let statusText = recent?.status || '-';
    let statusCls = '';
    if (statusKey === 'advancestatuslive' || statusKey === 'paid' || statusKey === 'success') {
      statusText = 'Paid'; statusCls = 'approved';
    } else if (statusKey === 'approved') {
      statusCls = 'approved';
    } else if (statusKey === 'pending') {
      statusCls = 'pending';
    } else if (statusKey === 'rejected' || statusKey === 'declined') {
      statusCls = 'rejected';
    }

    // type title
    const typeTitle =
      recent?.type === 'salaryTopUp'  ? 'Salary Top-Up' :
      recent?.type === 'salaryAdvance' ? 'Salary Advance' :
      (recent?.type || 'Request');

    // due / next due
    const nextDueText = (() => {
      if (recent?.type === 'salaryTopUp') {
        const bd = Array.isArray(recent?.paymentBreakdown) ? recent.paymentBreakdown : [];
        if (!bd.length) return '-';
        const now = Date.now();
        const future = bd
          .map(b => new Date(b.dueDate))
          .filter(d => !isNaN(d.getTime()) && d.getTime() >= now)
          .sort((a, b) => a.getTime() - b.getTime());
        const pick = future[0] || new Date(bd[bd.length - 1].dueDate);
        return moment(pick).format('DD MMM, YYYY');
      }
      if (recent?.dueDate) return moment(recent.dueDate).format('DD MMM, YYYY');
      const sd = recent?.salaryDueDate;
      if (!sd) return '-';
      if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(sd)) {
        const [d, m, y] = sd.split('-').map(Number);
        return moment(new Date(y, m - 1, d)).format('DD MMM, YYYY');
      }
      if (/^\d{1,2}$/.test(String(sd))) return `Due on ${sd}`;
      return sd;
    })();

    // installments (only for top-up)
    const installmentsText = (() => {
      if (recent?.type !== 'salaryTopUp') return null;
      const bd = Array.isArray(recent?.paymentBreakdown) ? recent.paymentBreakdown : [];
      if (!bd.length) return null;
      const per = bd[0]?.amount;
      const perNum = Number(typeof per === 'string' ? parseFloat(per) : per || 0);
      return `${bd.length} × N ${perNum.toLocaleString()}`;
    })();

    return (
      <div className="request-card" key={id}>
        {/* header */}
        <div className="request-card__header">
          <div className="request-card__date">
            {createdISO ? (
              <>
                <span className="d">{moment(createdISO).format('DD')}</span>
                <span className="of"> of </span>
                <span className="m">{moment(createdISO).format('MMM')}</span>
              </>
            ) : '-'}
          </div>
          <div className="request-card__tags">
            <span className="pill pill--type">{typeTitle}</span>
            <span className={`pill pill--${statusCls || 'neutral'}`}>{statusText}</span>
          </div>
        </div>

        {/* amount */}
        <div className="request-card__amount">
          <span className="label">Amount</span>
          <div className="value">
            <span className="cur">N</span>
            <span className="num">{amountNum.toLocaleString()}</span>
          </div>
        </div>

        {/* meta */}
        <div className="request-card__meta">
          <div className="meta-item">
            <span className="meta-label">{recent?.type === 'salaryTopUp' ? 'Next due' : 'Due date'}</span>
            <span className="meta-value">{nextDueText}</span>
          </div>
          {installmentsText && (
            <div className="meta-item">
              <span className="meta-label">Installments</span>
              <span className="meta-value">{installmentsText}</span>
            </div>
          )}
        </div>
      </div>
    );
  })
}
                          {withdrawalData?.length === 0 && <div className="no-data">No Recent Request</div>}

</div>
                    </aside>

                    {/* complete profile */}
                    {/* {checkProfileStatus ? '' : <CompleteProfile
                        handleToggleProfileStatus={handleToggleProfileStatus}
                    />} */}

                </div>
            }

            <ProfileStatus
                isOpen={isOpen}
                toggle={handleToggleProfileStatus}
                data={user}
            />
            <ErrorModal
                isOpen={errorPopup}
                toggleError={handleErrorPopup}
                message={customMessage}
                isProfileComplete={notUpdate}
            />

            
        </>
    )
}

export default HomePage
